import { Component, h, JSX } from 'preact';
import { sendAnalyticsTrack } from '../../../../../../common/js/TrackAnalyticsHelper';
import { RootStore } from '../../../../../../common/js/stores/root.store';
import { ControlsStrategy } from '../../../../../../common/js/stores/controls/default-controls-strategy';
import CustomizedControl from '../../../../../../common/components/customized-control';
import SoundControl from '../../../../../../common/components/sound-control';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface SoundItemProps {
  onToggleMute: (e: Event) => void;
  controlStyle: ControlStyle;
  iconSize: number;
  isVideoMuted: boolean;
  isInterstitialAdUnit: boolean;
  iconPadding: number;
}

export class SoundItem extends Component<SoundItemProps> {
  constructor(props: SoundItemProps) {
    super(props);
  }

  render(): JSX.Element | string {
    const rootStore = RootStore.getInstance();
    const controlStore: ControlsStrategy = rootStore.controlsStore;
    const videoStore = rootStore.videoStore;

    const {
      onToggleMute,
      controlStyle,
      iconSize,
      isVideoMuted,
      isInterstitialAdUnit,
      iconPadding
    } = this.props;
    return (
      <div data-zone="sound">
        {!videoStore.isVideoCompleted.value &&
        controlStore.shouldDisplayMuteButton() ? (
          <CustomizedControl
            id="sound"
            onTouchStart={(e: TouchEvent) => e.stopPropagation()}
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              onToggleMute(e);
              sendAnalyticsTrack(e);
            }}
            controlStyle={controlStyle}
            style={{
              padding: iconPadding,
              width: iconSize + iconPadding * 2,
              height: iconSize + iconPadding * 2
            }}
          >
            <SoundControl iconSize={iconSize} isMuted={isVideoMuted} />
          </CustomizedControl>
        ) : !isInterstitialAdUnit ? (
          <div style={{ width: iconSize + iconPadding * 2 }} />
        ) : (
          ''
        )}
      </div>
    );
  }
}
